import { render, staticRenderFns } from "./MenuOrderList.vue?vue&type=template&id=52a62820&"
import script from "./MenuOrderList.vue?vue&type=script&lang=js&"
export * from "./MenuOrderList.vue?vue&type=script&lang=js&"
import style0 from "./MenuOrderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports